export default __webpack_public_path__ + "static/media/quote03.77bfc815.png";